import { LIST_CHATBOT_OPTIONS, LIST_CHATBOT_OPTIONS_LOADING } from './constants';

const initialState = {
  options: [],
  loadingChatbotOptions: false,
};

export const chatbotReducer = (state = initialState, action) => {
  switch (action.type) {
    case LIST_CHATBOT_OPTIONS_LOADING:
      return {
        ...state,
        loadingChatbotOptions: action.loadingChatbotOptions,
      };
    case LIST_CHATBOT_OPTIONS:
      return {
        ...state,
        options: action.options,
      };
    default:
      return state;
  }
};
